/**
 * VSTD — Desvio Padrão do Volume.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLVolume.cs, classe FML.VSTD):
 *
 *   VSTD = STD(VOL, N)
 *
 * STD = desvio-padrão AMOSTRAL (Bessel): SQRT(VARP(VOL,N) · N/(N-1)), com
 * VARP = MA(SQR(VOL),N) − SQR(MA(VOL,N)) (ver silverlightDsl.js). Paridade
 * numérica provada contra o engine original em __tests__/vstd.silverlight.test.js.
 */
import { std } from "./silverlightDsl";
import { VSTD as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;

    // Família E1: desembrulha d.volume caso o indicador Volume já tenha
    // processado a barra ({volume, direction}) no mesmo pipeline.
    const vol = data.map((d) => {
      const raw = d.volume;
      const v =
        raw !== null && typeof raw === "object"
          ? Number(raw.volume)
          : Number(raw);
      return Number.isFinite(v) ? v : NaN;
    });

    const out = std(vol, period);

    // Borda com o chart: NaN (warm-up, volume ausente, cancelamento de float) → undefined.
    return out.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    return period - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
